import { getRecordList, getMediaUrl } from '@src/utils/media-data';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { getOmniData, Ids } from '@src/services/omni-api';
import Video from '@src/components/video';
import { go } from '@src/utils/promise';
import createHtmlLink from '@src/utils/create-html-link';
import Toast from '@src/components/toast';
import { formatNumber } from '@src/utils/format/num';
import $$tracker from '@src/tracker';

class KVStore extends BaseStore {
  // 首屏KV图片
  @observable kvImg;
  // 预约人数
  @observable orderCount = 0;
  // KV相关数据（包含图片和视频）
  @observable kvData = null;
  // 加载中防止连点
  @observable loading = false;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  /** 退出 */
  onLogout = async () => {
    const [data, err] = await go(this.$ztService.logout());
    if (err) {
      Toast.fail(err.message || '退出失败！');
      return;
    }
    Toast.success('退出成功！');
    this.mainStore.getConfig();
    // this.logout();
  };

  /** 获取kv信息 */
  getKVInfo = async () => {
    try {
      const res = await getOmniData(Ids.kv.channel, [{ dataSourceId: Ids.kv.dataSources.kv || '', page: 1, perPage: 99 }]);
      // 解析KV图片数据
      const kvItems = getRecordList(res?.[Ids.kv.dataSources.kv]?.result?.items);
      const kvItem = kvItems[0] || {};
      this.kvImg = getMediaUrl(kvItem.kv_image_mo);
      this.kvData = {
        kv_image: getMediaUrl(kvItem.kv_image),
        kv_pv_video: getMediaUrl(kvItem.homepage_kv),
        play_bg_img: getMediaUrl(kvItem.play_bg_img),
        kv_video: getMediaUrl(kvItem.kv_video)
      };
    } catch (error) {
      console.log(error);
    }
  };

  /** 获取预约人数 */
  getReservedNum = async () => {
    const [res, err] = await go(this.$ztService.getSubscribeCount());
    if (err) {
      Toast.fail(err.message || '获取预约人数失败');
      return;
    }
    this.orderCount = formatNumber(res?.subscribe_total || 0);
  };

  /** 打开预约弹窗 */
  onReservation = () => {
    if (this.mainStore?.projectConfig?.phone) return;
    $$tracker.clickReservation('首页');
    this.mainStore?.openOrderTipsModal();
  };
  /** 打开视频弹窗 */
  openVideoModal = () => {
    this.kvData?.kv_pv_video && Video.append({ src: this.kvData?.kv_pv_video });
  };

  /** 查询奖励资格 */
  openQueryLink = async () => {
    this.loading = true;
    const [res, err] = await go(this.$ztService.getCheckPrizeUrl());
    this.loading = false;
    if (err) {
      Toast.fail(err.message || '错误');
      return;
    }
    // TODO: 这里有一个bug是后端返回的链接有误。不应该含有多余的空格，应该是index.html? 而不是 /#/ ?
    res.check_prize_url && createHtmlLink(res.check_prize_url).click();
    $$tracker.clickRewardInquiry();
  };

  use() {
    super.use();
    useMount(() => {
      this.getKVInfo();
      this.getReservedNum();
    });
  }
}

export default KVStore;
